/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Step_Key_DescInputs */

const en_admin_indexnow_step_key_desc = /** @type {(inputs: Admin_Indexnow_Step_Key_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the key generated in Bing Webmaster Tools →`)
};

/**
* | output |
* | --- |
* | "Paste the key generated in Bing Webmaster Tools →" |
*
* @param {Admin_Indexnow_Step_Key_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_step_key_desc = /** @type {((inputs?: Admin_Indexnow_Step_Key_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Step_Key_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_step_key_desc(inputs)
});
export { admin_indexnow_step_key_desc as "admin.indexnow.step_key_desc" }